export const product = {
    back: 'Voltar',
    loading: 'Carregando produto...',
    inStock: 'Em estoque',
    outOfStock: 'Fora de estoque',
    features: 'Características',
    specifications: 'Especificações Técnicas',
    warranty: 'Garantia',
    shipping: 'Entrega',
    specificationsLabels: {
        battery: 'Bateria',
        flightTime: 'Tempo de Voo',
        range: 'Alcance',
        weight: 'Peso',
        camera: 'Câmera',
        gimbal: 'Gimbal',
        obstacleAvoidance: 'Detecção de Obstáculos',
        maxSpeed: 'Velocidade Máxima',
        maxAltitude: 'Altitude Máxima',
    },
    notFound: {
        title: 'Produto não encontrado',
        description: 'O produto que você está procurando não foi encontrado.',
        backToCatalog: 'Voltar ao catálogo',
    },
    video: {
        title: 'Vídeo Demonstrativo',
        description: 'Confira o drone em ação e conheça todas as suas funcionalidades',
    },
};
//# sourceMappingURL=product.js.map